import fetchFactory from '@picsart/rc/fetchFactory';

import traceback from 'utils/traceback';
import isServer from 'utils/shared/isServer';

import { Fetcher } from 'swr/dist/types';

const fetch = fetchFactory({
  baseUrl: '',
  withCache: false,
  headers: { platform: 'website' },
  withDeviceId: true,
  withLanguageHeader: true,
});

const fetcher: Fetcher<any> = (url: string, options?: RequestInit) =>
  fetch(url, options)
    .then(res => {
      if (isServer()) {
        return res.json();
      }

      return res.clone().json();
    })
    .catch(error => {
      // TODO:  Add error notification with notify param
      traceback({ path: 'src/utils/fetcher.ts', url, error });
    });

export default fetcher;
